import React from 'react'
import styles from './OverviewV2.module.scss'
import { OverviewV2MetaItem } from './OverviewV2MetaItem'
import { OverviewV2MetaItem as OverviewV2MetaItemType } from './types'

interface OverviewV2MetaListProps {
  items: OverviewV2MetaItemType[]
}

export const OverviewV2MetaList = ({ items }: OverviewV2MetaListProps) => {
  const visibleItems = items.filter(item => item.value !== undefined && item.value !== null && item.value !== '')
  if (!visibleItems.length) return null

  return (
    <div className={styles.metaList}>
      {visibleItems.map(item => (
        <React.Fragment key={item.key}>
          <OverviewV2MetaItem item={item} />
        </React.Fragment>
      ))}
    </div>
  )
}
